"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollbarClassNames = void 0;
/**
 * Use one of these className constants on a scrollable element
 * to apply a modified scrollbar style to it.
 */
const scrollbarClassNames = {
  slim: "lodestar--global-scrollbars--slim"
};
exports.scrollbarClassNames = scrollbarClassNames;
//# sourceMappingURL=scrollbars.js.map